module.exports = __webpack_public_path__ + "img/menu.f40d683e.svg";